import { render } from "./WorkAreaAvatar.vue?vue&type=template&id=395d1fd7"
import script from "./WorkAreaAvatar.vue?vue&type=script&lang=ts"
export * from "./WorkAreaAvatar.vue?vue&type=script&lang=ts"
script.render = render

export default script